import {GET, POST} from "@/services/gateway";

export const listSeats = ({pagination, searchTerm}) => {
  return POST('salesforce/user/list', {pagination, searchTerm})
}

export const refresh= () => {
  return GET('salesforce/users/refresh');
}
